module.exports = __webpack_public_path__ + "static/media/rawkstars.c774dff0.svg";